// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faq_main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  max-width: 100vw;
  padding: 1%;
}
.faq_main h2 {
  font-size: 3rem;
}
.faq_main .faq_text_main {
  font-size: 1.2rem;
  width: 40%;
  margin: 0 auto;
  text-align: center;
}
@media (min-width: 691px) and (max-width: 850px) {
  .faq_main h2 {
    font-size: 2rem;
  }
  .faq_main .faq_text_main {
    font-size: 1rem;
  }
}
@media (max-width: 690px) {
  .faq_main {
    padding: 3%;
  }
}
.faq_main span {
  font-size: x-small;
  vertical-align: text-top;
}
.faq_main table {
  width: 60%;
  margin: 2% auto;
  table-layout: fixed;
  background-color: #fff;
  border-collapse: collapse;
  color: #000;
  text-align: center;
  font-size: larger;
}
.faq_main table thead {
  border-bottom: 1px solid #000;
  text-transform: uppercase;
  font-weight: 600;
  color: white;
  background-color: #e63b11;
}
.faq_main table tbody tr {
  border-bottom: 1px solid #000;
}
.faq_main table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}

.services__tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 70vw;
  margin-left: 12vw;
  row-gap: 0.5rem;
}
.services__tab .tab_section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  transition: 2s ease;
}
.services__tab .tab_section .tab__title_open {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  background-color: #e63b11;
  padding-left: 0.7rem;
  border-radius: 12px;
  z-index: 10;
  height: 4.5rem;
}
.services__tab .tab_section .tab__title_open h3 {
  font-weight: 600;
  color: white;
}
@media (max-width: 690px) {
  .services__tab .tab_section .tab__title_open h3 {
    text-align: left;
  }
}
.services__tab .tab_section .tab__title_close {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  box-shadow: 0 14px 16px rgba(0, 0, 0, 0.1), 0 1px 30px rgba(0, 0, 0, 0.06);
  background-color: white;
  padding-left: 0.7rem;
  border-radius: 12px;
}
.services__tab .tab_section .tab__title_close h3 {
  font-weight: 600;
  color: black;
}
@media (max-width: 690px) {
  .services__tab .tab_section .tab__title_close h3 {
    text-align: left;
  }
}
.services__tab .tab_section .open__tab {
  margin-left: 2rem;
  margin-right: 2rem;
  padding-right: 2rem;
  background-color: transparent;
  transition: max-height 5s ease;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.services__tab .tab_section .open__tab li {
  color: #000;
}
.services__tab .tab_section .open__tab p {
  text-align: left;
  width: 100%;
  margin-bottom: 1%;
}
.services__tab .tab_section .open__tab video {
  margin: 1% auto;
}
.services__tab .tab_section .open__tab .form_link {
  color: #e63b11;
  text-decoration: none;
}
@media (max-width: 690px) {
  .services__tab {
    margin-left: -5vw;
    padding: 0 5%;
    width: 100vw;
  }
  .services__tab .tab_section .open__tab {
    width: 100%;
  }
}

#tabs_font {
  font-size: 1rem;
}
@media (max-width: 690px) {
  #tabs_font {
    font-size: 0.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/faq.scss","webpack://./src/components/styles/variables.scss"],"names":[],"mappings":"AAEA;EC8BI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ED/BF,gBAAA;EACA,WAAA;AAEF;AADE;EACE,eAAA;AAGJ;AADE;EACE,iBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;AAGJ;AADE;EACE;IACE,eAAA;EAGJ;EADE;IACE,eAAA;EAGJ;AACF;AADE;EArBF;IAsBI,WAAA;EAIF;AACF;AACE;EACE,kBAAA;EACA,wBAAA;AACJ;AACE;EACE,UAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AACJ;AAAI;EACE,6BAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBC/CG;ADiDT;AACM;EACE,6BAAA;AACR;AAAQ;EACE,yBAAA;AAEV;;AAKA;ECtBI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EDqBF,WAAA;EACA,iBAAA;EACA,eAAA;AACF;AAEE;EC3CE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;ED0CA,WAAA;EACA,mBAAA;AAGJ;AACI;EACE,uEAAA;ECXF,aAAA;EACA,mBAAA;EACA,8BAAA;EDWE,WAAA;EACA,eAAA;EACA,yBC/EG;EDgFH,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AAGN;AAAM;EACE,gBAAA;EACA,YAAA;AAER;AAAM;EACE;IACE,gBAAA;EAER;AACF;AACI;EChCA,aAAA;EACA,mBAAA;EACA,8BAAA;EDgCE,WAAA;EACA,eAAA;EACA,0EAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;AAGN;AAAM;EACE,gBAAA;EACA,YAAA;AAER;AAAM;EACE;IACE,gBAAA;EAER;AACF;AACI;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,8BAAA;ECjGF,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;ADmGJ;AAHM;EACE,WAAA;AAKR;AAHM;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;AAKR;AAHM;EACE,eAAA;AAKR;AAHM;EACE,cCvIC;EDwID,qBAAA;AAKR;AADE;EAhFF;IAiFI,iBAAA;IACA,aAAA;IACA,YAAA;EAIF;EAFI;IACE,WAAA;EAIN;AACF;;AACA;EACE,eAAA;AAEF;AADE;EAFF;IAGI,kBAAA;EAIF;AACF","sourcesContent":["@import \"./variables.scss\";\n\n.faq_main {\n  @include columnStartCenter;\n  max-width: 100vw;\n  padding: 1%;\n  h2 {\n    font-size: 3rem;\n  }\n  .faq_text_main {\n    font-size: 1.2rem;\n    width: 40%;\n    margin: 0 auto;\n    text-align: center;\n  }\n  @media (min-width: $tabletMin) and (max-width: $tabletMax) {\n    h2 {\n      font-size: 2rem;\n    }\n    .faq_text_main {\n      font-size: 1rem;\n    }\n  }\n  @media (max-width: $mobile) {\n    padding: 3%;\n    .faq_text_main {\n      // font-size: .9rem;\n      // width: 80%;\n    }\n  }\n  span {\n    font-size: x-small;\n    vertical-align: text-top;\n  }\n  table {\n    width: 60%;\n    margin: 2% auto;\n    table-layout: fixed;\n    background-color: #fff;\n    border-collapse: collapse;\n    color: #000;\n    text-align: center;\n    font-size: larger;\n    thead {\n      border-bottom: 1px solid #000;\n      text-transform: uppercase;\n      font-weight: 600;\n      color: #ffff;\n      background-color: $orange;\n    }\n    tbody {\n      tr {\n        border-bottom: 1px solid #000;\n        &:nth-child(odd) {\n          background-color: #f2f2f2;\n        }\n      }\n    }\n  }\n}\n\n.services__tab {\n  @include columnStack;\n  width: 70vw;\n  margin-left: 12vw;\n  row-gap: 0.5rem;\n\n  // box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  .tab_section {\n    @include columnStart;\n    width: 100%;\n    transition: 2s ease;\n\n    // border-bottom: 1px solid $orange;\n\n    .tab__title_open {\n      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06);\n      @include rowBetween;\n      width: 100%;\n      cursor: pointer;\n      background-color: $orange;\n      padding-left: 0.7rem;\n      border-radius: 12px;\n      z-index: 10;\n      height: 4.5rem;\n      // transition: 2s ease;\n      // margin-bottom: 20px;\n      h3 {\n        font-weight: 600;\n        color: white;\n      }\n      @media (max-width: $mobile) {\n        h3 {\n          text-align: left;\n        }\n      }\n    }\n    .tab__title_close {\n      @include rowBetween;\n      width: 100%;\n      cursor: pointer;\n      box-shadow: 0 14px 16px rgba(0, 0, 0, 0.1), 0 1px 30px rgba(0, 0, 0, 0.06);\n      background-color: white;\n      padding-left: 0.7rem;\n      border-radius: 12px;\n      // transition: 2s ease;\n      // margin-bottom: 20px;\n      h3 {\n        font-weight: 600;\n        color: black;\n      }\n      @media (max-width: $mobile) {\n        h3 {\n          text-align: left;\n        }\n      }\n    }\n    .open__tab {\n      margin-left: 2rem;\n      margin-right: 2rem;\n      padding-right: 2rem;\n      background-color: transparent;\n      transition: max-height 5s ease;\n      @include columnStart;\n      li {\n        color: #000;\n      }\n      p {\n        text-align: left;\n        width: 100%;\n        margin-bottom: 1%;\n      }\n      video {\n        margin: 1% auto;\n      }\n      .form_link {\n        color: $orange;\n        text-decoration: none;\n      }\n    }\n  }\n  @media (max-width: $mobile) {\n    margin-left: -5vw;\n    padding: 0 5%;\n    width: 100vw;\n    .tab_section {\n      .open__tab {\n        width: 100%;\n      }\n    }\n  }\n}\n\n#tabs_font {\n  font-size: 1rem;\n  @media (max-width: $mobile) {\n    font-size: 0.75rem;\n  }\n}\n","//colours\n$orange: #e63b11;\n$font: #000;\n$lightGrey: #d1d3d4;\n$darkGrey: #939598;\n$darkBlue: #01426a;\n$lightBlue: #77c5d5;\n\n//mobile breaks\n$mobilemin:100;\n$mobile: 690px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1000px;\n$landsTabletMin2: 1000px;\n$landsTabletMax2: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@mixin columnStart{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin columnStartCenter{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin columnStack{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnCenter{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin rowEven{\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowEvenStart{\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n\n@mixin rowBetween{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart{\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin button {\n        background-color: $orange;\n        color: #fff;\n        text-transform: uppercase;\n        border: none;\n        // height: 3rem;\n        border-radius: 1.5rem;\n        letter-spacing: 0.1rem;\n        font-weight: 600;\n        // margin: 3% auto;\n        transition: background-color 0.3s ease;\n        padding: 0 2rem;\n        cursor: pointer;\n        \n        &:hover {\n          background-color: #000;\n        }\n      \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
